import { createEntityAdapter } from '@reduxjs/toolkit';
import { IMinimumWage } from 'types/minimum-wage';

const minimumWagesAdapter = createEntityAdapter<IMinimumWage>({
  selectId: minWage => minWage.id,
});

export default minimumWagesAdapter;
